import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  CRM_PERMISSION,
  CRM_PERMISSION_SUCCESS,
  CRM_PERMISSION_ERROR,
} from "../action-types/userInfo";
import api from '../apis/h5-sidebar/customer/potential-customer'
import crmPermissionReducer from '../reducers/crmPermisson'

reducerRegistry.register('crmPermission', crmPermissionReducer)

export function getCrmPermission() {
  return {
    types: [CRM_PERMISSION, CRM_PERMISSION_SUCCESS, CRM_PERMISSION_ERROR],
    callAPI: () => api.getCrmPermission(),
  };
}